module.exports = __webpack_public_path__ + "static/media/KMH_5410.3427ac6b.jpg";